module.exports = __webpack_public_path__ + "components/flag/static/square/bl-2352aaf44aff8c5aabc9385ce76773f8.svg";